import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams  } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as theGlobals from '../shared/globals';

import { EFileApplicationDto } from '../application/efile/dto/efile-app.dto';
import { EFilePaymentDto } from '../application/efile/dto/efile-payment.dto';
// import { AuthService } from '@auth0/auth0-angular';
import { UtilitiesService } from './utilities.service';


/*
import { ICaseList } from '../shared/classes/case-list';
import { ICase } from '../shared/classes/case';
import { IProperty } from '../shared/classes/property';
import { IApplicant } from '../shared/classes/applicant';
import { AgencyDto } from '../application/agencies/agency.dto';
import { ApplicationValueDto } from '../application/case/dto/application-value.dto';
import { ApplicationAgentDto } from '../application/case/dto/application-agent.dto';
import { ApplicationAssessorDto } from '../application/case/dto/application-assessor.dto';
import { ApplicationMinutesDto } from '../application/case/dto/application-minutes.dto';
import { ApplicationStatusDto } from '../application/case/dto/application-status.dto';
*/

@Injectable()

export class EfileService {
    private myEfileUrl = theGlobals.setEnv().eFileUrl;
    private myTokenUrl = theGlobals.setEnv().tokenUrl;
    private isSBProd = theGlobals.setEnv().isSBProd;
    private myBernie = {
        token: ''
    };

    constructor(private http: HttpClient,
                private utilService: UtilitiesService) {}

    initBernie() {
        if (this.isBernieHere()) { return; }  // we already have Bernie...
        this.pingSBProdEFileSys().subscribe(data => {
            // console.log('results of pinging...');
            // console.log(data);
            this.myBernie.token = data.access_token;
        });
    }
    isBernieHere(): boolean {
      return this.myBernie.token ? true : false;
    }
    // generate headers object passed in each web service call
    private getBernie(): HttpHeaders {
        if (this.myBernie) {
            const headers = new HttpHeaders(
                {
                    Authorization: 'Bearer ' + this.myBernie.token,
                    Accept: 'application/json;odata=verbose'
                }
            );
            return headers;
        }
        else {
            return new HttpHeaders();
        }
    }

    // get list of Applications efiled during specified year, w/ specified filing status
    // filing status:   1 (In Progress), 2 (), 3 (Submitted), 4 (Accepted by/Imported into Assessment Appeals)
    getApplicationList(myYear: string, myStatus: number = 3): Observable<EFileApplicationDto[]> {
        // ('getting application list for status: ' + myStatus);
        const xUrl = this.myEfileUrl + '/application/filingstatus/' + myStatus + '/year/' + myYear;
        return this.http.get<EFileApplicationDto[]>(xUrl, { headers: this.getBernie()} );
    }

    // get efiled application data (from E-File system)
    getEfiledApplication(efileId: any): Observable<any> {
        const xUrl = this.myEfileUrl + '/application/' + efileId;
        return this.http.get<any>(xUrl, { headers: this.getBernie()});
    }

    // get documents uploaded during EFiling process
    getEFileDocs(efileId: string): Observable<any[]> {
        const xUrl = this.myEfileUrl + '/application/' + efileId + '/attachments';
        return this.http.get<any[]>(xUrl, { headers: this.getBernie()});
    }
    updateEfileStatus(efileId: any, efileStatus: string): Observable<any> {
        const xUrl = this.myEfileUrl + '/application/' + efileId + '/filingstatus/' + efileStatus;
        return this.http.put(xUrl, null, { headers: this.getBernie()});
    }

    updateEfileMgtCaseNumber(mgmtCaseNum: string, efileId: string): Observable<any> {
        const xUrl = this.myEfileUrl + '/application/' + efileId + '/applicationNumber/' + mgmtCaseNum;
        return this.http.put(xUrl, null, { headers: this.getBernie()});
    }

    getEfiledDocUrl(efileId: any): string {
        return this.myEfileUrl + '/application';
    }

    // get Payment data; will only pick up records containing a TransactionId, i.e. w/ statusId = 3 (completed)
    getPaymentInfo(efileId: any): Observable<EFilePaymentDto[]> {
        const xUrl = this.myEfileUrl + '/application/' + efileId + '/payments';
        return this.http.get<EFilePaymentDto[]>(xUrl, { headers: this.getBernie()});

    }

    // get list of ALL e-Filed applications, regardless of year & status; primarily used for troubleshooting purposes
    getAllApplications(): Observable<any[]> {
        const xUrl = this.myEfileUrl + '/application';
        return this.http.get<any[]>(xUrl, { headers: this.getBernie()});
    }

    // get list of Registered Users; used to diagnose registration-related problems
    getRegisteredUsers(): Observable<any[]> {
        const xUrl = this.myEfileUrl + '/regusers';
        return this.http.get<any[]>(xUrl, { headers: this.getBernie()});
    }

        /// validate multiple applications; confirm each application has sufficient data for submission
    validateApps(data): Observable<any> {
        // data will contain an array of application Ids
        const xURL = this.myEfileUrl + '/application/validate';
        return this.http.post(xURL, data, { headers: this.getBernie()});
    }

    private handleError(err: HttpErrorResponse) {
        // in a real world app, we may send the error to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        const status = err.status;
        if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return Observable.throw(status);
    }

    // used in call to get token
    private genBernieParams(): HttpParams {
        const parms = new HttpParams();
        parms.set('userName', encodeURIComponent('prd3@gmx.us'));
        // password=" + encodeURIComponent('watcha6!U2') + "&grant_type=password"
        parms.set('password', encodeURIComponent('watcha6!U2'));
        parms.set('grant_type', 'password');
        return parms;
    }
  pingSBProdEFileSys(): Observable<any> {
    const bern = this.genBernieData();
    this.utilService.doAudit(this.myTokenUrl, 'getting bernie from:');
    return this.http.post(this.myTokenUrl, bern);
    // return this.http.post(this.myTokenUrl, { params: params })
  }
  private genBernieData(): string {
    return 'userName=' + encodeURIComponent('prd3@gmx.us') + '&password=' + encodeURIComponent('watcha6!U2') + '&grant_type=password';
  }

    /*
    pingEFileSys(): Observable<any> {
      const bern = this.genBernieData();
      // console.log('pinging Efile system to get Bernie...');
      return this.http.post(this.myTokenUrl, bern);
      // return this.http.post(this.myTokenUrl, { params: params })
    }
    private genBernieData(): string {
        return 'userName=' + encodeURIComponent('prd3@gmx.us') + '&password=' + encodeURIComponent('watcha6!U2') + '&grant_type=password';
    }
     */


}
